import './App.scss';

// pages
import Home from './pages/Home/Home.jsx';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
